(() => {
  if (window.__cartDrawerRecsInit) return;
  window.__cartDrawerRecsInit = true;

  const CONTAINER_SEL = '[data-cart-drawer-recommendations]';
  const GRID_SEL = '.cart-drawer-recs__grid';
  const COLLECTION_HANDLE = 'alle-produkte';
  let loaded = false;

  function getCartHandles() {
    const rows = document.querySelectorAll('.cart-drawer__form .cart-item');
    const handles = [];
    rows.forEach((row) => {
      const link = row.querySelector('.cart-item__name');
      if (link) {
        const href = link.getAttribute('href') || '';
        const match = href.match(/\/products\/([\w-]+)/);
        if (match) handles.push(match[1]);
      }
    });
    return handles;
  }

  async function fetchCollectionProducts() {
    const container = document.querySelector(CONTAINER_SEL);
    if (!container) return;

    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = `${root}collections/${COLLECTION_HANDLE}/products.json?limit=20`;
      const resp = await fetch(url, { credentials: 'same-origin' });
      const data = await resp.json();

      if (!data.products || data.products.length === 0) {
        container.setAttribute('hidden', '');
        return;
      }

      const cartHandles = getCartHandles();
      const filtered = data.products.filter(
        (p) => p.variants.some((v) => v.available) && !cartHandles.includes(p.handle)
      );

      if (filtered.length === 0) {
        container.setAttribute('hidden', '');
        return;
      }

      const shuffled = filtered.sort(() => 0.5 - Math.random());
      renderCards(shuffled.slice(0, 4));
      container.removeAttribute('hidden');
    } catch (e) {
      console.error('Cart drawer recommendations error:', e);
      container.setAttribute('hidden', '');
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  // Spiegelt snippets/price.liquid:
  //   1) reiner Zahlen-Tag 1-99  = Prozentrabatt
  //   2) Tag "eur<Betrag>"       = fester Eurobetrag (eur2.5 = 2,50 EUR)
  // Je Art gewinnt der hoehere Wert; zwischen beiden gewinnt der NIEDRIGERE
  // Endpreis. Sie werden nie kombiniert. Der Prozentrabatt wird - wie bei
  // Shopify - auf den Rabattbetrag kaufmaennisch gerundet.
  // Gibt den rabattierten Preis in Cent zurueck oder null.
  function tagDiscountedPrice(tags, priceCents) {
    if (!priceCents) return null;

    let list = [];
    if (Array.isArray(tags)) {
      list = tags;
    } else if (typeof tags === 'string') {
      list = tags.split(',');
    } else {
      return null;
    }

    let percent = 0;
    let amount = 0;

    list.forEach((raw) => {
      const tag = String(raw).trim();
      if (!tag) return;

      // 1) reine Zahl 1-99, ohne fuehrende Null
      if (/^[1-9][0-9]?$/.test(tag)) {
        const pct = parseInt(tag, 10);
        if (pct > percent) percent = pct;
      }

      // 2) "eur<Zahl>"
      const eur = tag.toLowerCase().match(/^eur([0-9]+(?:\.[0-9]+)?)$/);
      if (eur) {
        const cents = Math.round(parseFloat(eur[1]) * 100);
        if (cents > amount) amount = cents;
      }
    });

    let result = null;
    if (percent > 0) {
      result = priceCents - Math.round((priceCents * percent) / 100);
    }
    if (amount > 0) {
      const byAmount = Math.max(0, priceCents - amount);
      if (result === null || byAmount < result) result = byAmount;
    }
    return result;
  }

  function renderCards(products) {
    const grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    // Tag-Rabatte werden - wie ueberall sonst im Theme - erst gezeigt,
    // wenn ein Rabattcode aktiv ist (body.discount-active).
    const discountActive = document.body.classList.contains('discount-active');

    grid.innerHTML = products
      .map((p) => {
        const variant = p.variants[0];
        const price = Math.round(parseFloat(variant.price) * 100) || 0;
        const compareAt = Math.round(parseFloat(variant.compare_at_price) * 100) || 0;
        const img = p.images && p.images[0]
          ? p.images[0].src.replace(/(\.\w+)\?/, '_300x$&').replace(/\?.*/, '') + '?width=300'
          : '';

        const discounted = discountActive ? tagDiscountedPrice(p.tags, price) : null;
        const hasTagSale = discounted !== null && discounted < price;
        const hasCompare = compareAt > price;
        const priceClass = hasTagSale || hasCompare ? ' cart-drawer-recs__price--sale' : '';

        let priceHtml;
        if (hasTagSale) {
          priceHtml = `<span class="cart-drawer-recs__current">${formatMoney(discounted)}</span><s class="cart-drawer-recs__compare">${formatMoney(price)}</s>`;
        } else if (hasCompare) {
          priceHtml = `<span class="cart-drawer-recs__current">${formatMoney(price)}</span><s class="cart-drawer-recs__compare">${formatMoney(compareAt)}</s>`;
        } else {
          priceHtml = `<span class="cart-drawer-recs__current">${formatMoney(price)}</span>`;
        }

        return `
        <div class="cart-drawer-recs__card">
          <a href="/products/${p.handle}" class="cart-drawer-recs__image-link">
            ${img ? `<img src="${img}" alt="${p.title}" loading="lazy" width="100" height="100">` : ''}
          </a>
          <div class="cart-drawer-recs__info">
            <a href="/products/${p.handle}" class="cart-drawer-recs__title">${p.title}</a>
            <div class="cart-drawer-recs__price${priceClass}">
              ${priceHtml}
            </div>
          </div>
          <button
            type="button"
            class="cart-drawer-recs__add"
            data-variant-id="${variant.id}"
            aria-label="In den Warenkorb"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </button>
        </div>`;
      })
      .join('');
  }

  async function addToCart(variantId, button) {
    button.disabled = true;
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const resp = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        credentials: 'same-origin',
      });

      if (!resp.ok) throw new Error('Add failed');

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const sectionResp = await fetch(
          `${root}cart?section_id=cart-drawer`,
          { credentials: 'same-origin' }
        );
        const html = new DOMParser().parseFromString(await sectionResp.text(), 'text/html');

        // Selectors to swap from the freshly rendered section.
        const refreshSelectors = [
          'cart-drawer-items',
          '.cart-drawer__footer',
          '.cart-drawer-shipping-progress',
          'tier-discount-progress',
        ];
        refreshSelectors.forEach((sel) => {
          const fresh = html.querySelector(sel);
          const current = document.querySelector(sel);
          if (fresh && current) current.replaceWith(fresh);
        });

        const heading = document.querySelector('.drawer__heading');
        const newHeading = html.querySelector('.drawer__heading');
        if (heading && newHeading) heading.innerHTML = newHeading.innerHTML;

        const bubbleResp = await fetch(
          `${root}cart?section_id=cart-icon-bubble`,
          { credentials: 'same-origin' }
        );
        const bubbleHtml = new DOMParser().parseFromString(await bubbleResp.text(), 'text/html');
        const newBubble = bubbleHtml.querySelector('#cart-icon-bubble');
        const oldBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;

        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      }

      // Notify other listeners (e.g. PDP tier bar, price-per-item, etc.)
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          const cartResp = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
          const cartData = cartResp.ok ? await cartResp.json() : null;
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-recommendations', cartData });
        } catch (_) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-recommendations' });
        }
      }

      loadRecommendations();
    } catch (e) {
      console.error('Cross-sell add error:', e);
    } finally {
      button.disabled = false;
    }
  }

  function loadRecommendations() {
    loaded = false;
    fetchCollectionProducts();
    loaded = true;
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-drawer-recs__add');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (variantId) addToCart(parseInt(variantId, 10), btn);
  });

  const observer = new MutationObserver(() => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('is-empty')) {
      loadRecommendations();
    }
  });

  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    observer.observe(drawerEl, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(loadRecommendations, 500);
    });
  }
})();